module.exports = __webpack_public_path__ + "static/media/smash-selector-color.0d6726a8.png";